import { render, staticRenderFns } from "./TheAuth.vue?vue&type=template&id=44d745c2"
import script from "./TheAuth.vue?vue&type=script&lang=ts"
export * from "./TheAuth.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports